"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SlideControlButtons;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _carouselControl = require("../../../page-body/sections/smart-testimonials-section/carousel-control");
var _icon = require("@site/pattern-library-utils/icon");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ActiveIcon = /*#__PURE__*/(0, _react2.styled)(_carouselControl.IconWrapper)({
  name: "ActiveIcon",
  class: "pl-al7s0d2"
});
const PaginationButton = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "PaginationButton",
  class: "pl-p1og824p"
});
const PrevButton = /*#__PURE__*/(0, _react2.styled)(PaginationButton)({
  name: "PrevButton",
  class: "pl-p1dwbz6b"
});
const NextButton = /*#__PURE__*/(0, _react2.styled)(PaginationButton)({
  name: "NextButton",
  class: "pl-nm402as"
});
const SlideControls = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SlideControls",
  class: "pl-sivtx8e"
});

/**
 * SlideControlButtons component.
 *
 * @param {Object} props React props
 * @param {string} props.prevCallback The function triggered when clicking the previous button
 * @param {string} props.nextCallback The function triggered when clicking the next button
 * @param {string} props.timeout How long the progress circle should take to complete
 * @param {string} props.rate How fast in ms does the progress circle update progress
 * @param {string} props.disableAnimation Whether or not animations should be triggered
 * @param {array} props.nextButtonAriaLabel THe aria label text for the Next Button
 * @param {string} props.prevButtonAriaLabel The aria label text for the Previous Button
 * @param {string} props.dataCy The data-cy attribute for this component
 * @returns {React.ReactElement} SlideControlButtons component
 * @public
 */
function SlideControlButtons({
  prevCallback,
  nextCallback,
  timeout,
  rate = 10,
  disableAnimation,
  nextButtonAriaLabel = 'Next',
  prevButtonAriaLabel = 'Previous',
  dataCy = 'slide-controls'
}) {
  const [offset, setOffset] = (0, _react.useState)(0);
  const circumference = 2 * Math.PI * 47;
  const [progress, setProgress] = (0, _react.useState)(disableAnimation ? 100 : 0);
  const [animate, setAnimate] = (0, _react.useState)(!disableAnimation);
  (0, _react.useEffect)(() => {
    setAnimate(!disableAnimation);
  }, [disableAnimation]);
  (0, _react.useEffect)(() => {
    let currProgress = animate ? progress : timeout;
    if (currProgress + rate >= timeout) {
      animate && nextCallback();
      currProgress = 0;
    }
    const id = setInterval(() => {
      setProgress(currProgress + rate);
    }, rate);
    return () => clearInterval(id);
  }, [progress, animate]);
  (0, _react.useEffect)(() => {
    const progressOffset = (timeout - progress) / timeout * circumference;
    setOffset(animate ? progressOffset : 0);
  }, [setOffset, circumference, progress, offset]);
  return /*#__PURE__*/_react.default.createElement(SlideControls, {
    "data-cy": dataCy
  }, /*#__PURE__*/_react.default.createElement(PrevButton, {
    "aria-label": prevButtonAriaLabel,
    onClick: prevCallback,
    onMouseEnter: () => setAnimate(false),
    onMouseLeave: () => setAnimate(!disableAnimation),
    "data-cy": `${dataCy}-prev`
  }, /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    "aria-label": "previous",
    role: "img"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 44.65,
    strokeWidth: 3.57
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 44.65,
    strokeWidth: 3.57
  })), /*#__PURE__*/_react.default.createElement(ActiveIcon, null, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-left",
    "aria-hidden": "true"
  }))), /*#__PURE__*/_react.default.createElement(NextButton, {
    "aria-label": nextButtonAriaLabel,
    onClick: nextCallback,
    onMouseEnter: () => setAnimate(false),
    onMouseLeave: () => setAnimate(!disableAnimation),
    "data-cy": `${dataCy}-next`
  }, /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    "aria-label": "next",
    role: "img"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 44.65,
    strokeWidth: 3.57
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 44.65,
    strokeWidth: 3.57,
    strokeDasharray: circumference,
    strokeDashoffset: offset
  })), /*#__PURE__*/_react.default.createElement(ActiveIcon, null, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-left",
    "aria-hidden": "true"
  }))));
}
SlideControlButtons.propTypes = {
  prevCallback: _propTypes.default.func,
  nextCallback: _propTypes.default.func,
  timeout: _propTypes.default.number,
  rate: _propTypes.default.number,
  disableAnimation: _propTypes.default.bool,
  prevButtonAriaLabel: _propTypes.default.string,
  nextButtonAriaLabel: _propTypes.default.string,
  dataCy: _propTypes.default.string
};